module.exports = __webpack_public_path__ + "static/media/speed.1cfc5688.svg";